(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('EnvironmentDetailController', EnvironmentDetailController);

    EnvironmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Environment', 'Tenant'];

    function EnvironmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Environment, Tenant) {
        var vm = this;

        vm.environment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:environmentUpdate', function(event, result) {
            vm.environment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
